Hop.defineModule('sso-email-check', (root, param) => {
    const emailInput = root.querySelector(param.emailInputId);
    const regularLoginButton = root.querySelector(param.regularLoginButtonId);
    const ssoLoginButton = root.querySelector(param.ssoLoginButtonId);
    const passwordSpan = root.querySelector(param.passwordSpanId);
    const passwordInput = root.querySelector(param.passwordInputId);

    const debouncedCheckForSsoOrganization = Hop.debounce(checkForSsoOrganization, 100);

    let ssoDisplayed = false;

    function setupEventListeners() {
        emailInput.addEventListener('input', debouncedCheckForSsoOrganization);
        emailInput.addEventListener('blur', checkForSsoOrganization);
        emailInput.addEventListener('keypress', submitFormOnEnterKeyPressIfNecessary);
    }

    function removeEventListeners() {
        emailInput.removeEventListener('input', debouncedCheckForSsoOrganization);
        emailInput.removeEventListener('blur', checkForSsoOrganization);
        emailInput.removeEventListener('keypress', submitFormOnEnterKeyPressIfNecessary);
    }

    function submitFormOnEnterKeyPressIfNecessary(event) {
        if (!ssoDisplayed || !(event.which === 13 || event.keyCode === 13)) {
            return;
        }

        event.preventDefault();
        ssoLoginButton.click();
    }

    function showSsoLoginButton(authenticationUrl, organizationName) {
        regularLoginButton.classList.add('hidden');
        passwordSpan.classList.add('hidden');
        passwordInput.required = false;

        ssoLoginButton.href = authenticationUrl;
        ssoLoginButton.textContent = Hop.message('signin.new.connect.with.sso', organizationName);
        ssoLoginButton.classList.remove('hidden');

        ssoDisplayed = true;
    }

    function showRegularLoginButton() {
        regularLoginButton.classList.remove('hidden');
        passwordSpan.classList.remove('hidden');
        passwordInput.required = true;

        ssoLoginButton.classList.add('hidden');

        ssoDisplayed = false;
    }

    function checkForSsoOrganization() {
        if (!emailInput.value) {
            showRegularLoginButton();
            return;
        }

        const simpleEmailRegex = /.+@.+\..+/;
        if (!simpleEmailRegex.test(emailInput.value)) {
            return;
        }

        fetch('/sso/api/enabled', {
            method: 'POST',
            body: JSON.stringify({email: emailInput.value}),
            headers: {'Content-Type': 'application/json'},
        })
            .then((response) => response.json())
            .then((data) => {
                if (!data.enabled) {
                    showRegularLoginButton();
                    return;
                }

                showSsoLoginButton(data.authenticationUrl, data.organizationName);
            });
    }

    setupEventListeners();
    checkForSsoOrganization();

    return function destroy() {
        removeEventListeners();
    };
});
